import React, { useState } from "react";
import style from "./header.module.css";
import { Icons } from "../utils/Icons";
import { useNavigate } from "react-router-dom";
import routeNames from "../utils/routes.json";
import PlansModal from "./PlansModal";
import { useDispatch } from "react-redux";
import { logout } from "../redux/counterSlice";

function Header() {
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const [isPlansOpen, setIsPlansOpen] = useState(false);
  const [isLogoutOpen, setIsLogoutOpen] = useState(false);
  const [name, setName] = useState("Home");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const routes = [
    { name: "Home", link: "/" },
    { name: "Add Product", link: routeNames["product-dashboard"] },
    { name: "Order List", link: routeNames["Order-list"] },
    { name: "Sales", link: routeNames["sale-s"] },
    { name: "Payment", link: routeNames["pay-ment"] },
    { name: "Chat Here", link: routeNames["chat-panel"] },
    { name: "Sports", link: routeNames["support-s"] },
    { name: "Settings", link: routeNames["add-category"] },
    { name: "Log Out", action: () => setIsLogoutOpen(true) },
  ];

  const toggleDrawer = () => {
    setIsDrawerVisible((prev) => !prev);
  };

  const handleLogout = () => {
    dispatch(logout());
    
    setIsDrawerVisible(false);
    setIsLogoutOpen(false);
    
    navigate("/login");
  };

  const onClick = (val, linkOrAction) => {
    setName(val);
    if (typeof linkOrAction === 'function') {
      linkOrAction();
    } else {
      navigate(linkOrAction);
    }
    setIsDrawerVisible(false);
  };

  return (
    <div className={style.mainWrapper + " flex justify-between items-center"}>
      <div className={style.logo}>
        <h2 className="text-2xl sm:text-3xl font-bold text-gray-800">
          <span className="text-5xl text-black">K</span>hushalli
        </h2>
      </div>

      <div className="hidden md:block ml-auto">
        <button
          onClick={() => setIsPlansOpen(true)}
          className="bg-black text-white mr-2 px-4 py-2 rounded hover:bg-gray-800"
        >
          Plans
        </button>
      </div>
      
      <div className={style.rightIcon}>
        <Icons.Menu color="#202224" onClick={toggleDrawer} />
      </div>
      
      {isDrawerVisible && (
        <div className={style.drawerWrapper}>
          <div className={`${style.drawer} ${isDrawerVisible ? style.drawerVisible : ""}`}>
            <div className={style.drawerHeader}>
              <h2>Menu</h2>
              <span onClick={toggleDrawer} className={style.closeButton}>
                ✖
              </span>
            </div>
            <ul>
              {routes.map((e) => (
                <li
                  key={e.name}
                  className={name === e.name ? style.active : ""}
                  onClick={() => onClick(e.name, e.link || e.action)}
                >
                  {e.name}
                </li>
              ))}
              <li
                className={style.plansButtonMobile}
                onClick={() => {
                  setIsPlansOpen(true);
                  setIsDrawerVisible(false);
                }}
              >
                Plans
              </li>
            </ul>
          </div>
          <div className={style.drawerOverlay} onClick={toggleDrawer}></div>
        </div>
      )}

      {isLogoutOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm bg-black/40 px-4"
          onClick={() => setIsLogoutOpen(false)}
        >
          <div 
            className="bg-white rounded-lg shadow-lg p-6 w-full max-w-sm" 
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className="text-center text-lg font-semibold mb-6">Are You Sure You want to log out?</h2>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <button 
                onClick={() => setIsLogoutOpen(false)} 
                className="w-full sm:w-auto px-4 py-2 border rounded hover:bg-gray-100 transition"
              >
                Cancel
              </button>
              <button 
                onClick={handleLogout} 
                className="w-full sm:w-auto px-4 py-2 bg-black text-white rounded hover:bg-gray-800 transition"
              >
                Log out
              </button>
            </div>
          </div>
        </div>
      )}
      
      <PlansModal isOpen={isPlansOpen} onClose={() => setIsPlansOpen(false)} />
    </div>
  );
}

export default Header;